import { CUSTOMER_LIST, CUSTOMER_AREA_FILTER, CUSTOMER_COMPANY_NAME_FILTER } from '../../mutationTypes'
import _ from 'lodash';

const mutations = {
  [CUSTOMER_AREA_FILTER](state, action){
    const filter = _.clone(state.filter);
    filter.area = action.area;
    state.filter = filter;
  },
  [CUSTOMER_COMPANY_NAME_FILTER](state, action){
    const filter = _.clone(state.filter);
    filter.companyName = action.companyName;
    state.filter = filter;
  },
  [CUSTOMER_LIST](state, action){
    state.items = action.items
  }
};

export default mutations;



// WEBPACK FOOTER //
// ./client/store/modules/customer/customerMutations.js